<template>
    <div class="headingbasicdetailsrules">
        <p class="notification">Specify what constitutes a policy violation. Use the toggles on the right to turn on the rules you want to use. For configurable rules, set the values you want to use.
            Active rules show a "Default Actions" button for managing violation actions.
        </p>

        <h1>All Trips</h1>
        <Alltrips @allTrips="getRules" :value="getValue('allTrips')"/><hr />
        
        <h1>Air Rules</h1>
        <LowestLogicalAirfare @lowestLogicalAirfare="getRules" :value="getValue('lowestLogicalAirfare')" /><hr/>
        <DomesticAirFareCap @domesticAirfareCap="getRules" :value="getValue('domesticAirfareCap')"/><hr />
        <InternationalAirFareCap @internationalAirfareCap="getRules"  :value="getValue('internationalAirfareCap')"/><hr />
        <AirlineVendor @airPreferredVendor="getRules" :value="getValue('airPreferredVendor')" /><hr />
        <PurchaseAirlines @hideInstantPurchase="getRules" :value="getValue('hideInstantPurchase')" /><hr />
        <AirRefundable @airRefundable="getRules" :value="getValue('airRefundable')" /><hr/>
        <ClassOfService @flightClassOfService="getRules"  :value="getValue('flightClassOfService')"/><hr />
        <AirHideNDC @hideNdc="getRules" :value="getValue('hideNdc')" /><hr/>
        <UnusedTickets @update="getRules" :value="getValue('useUnusedTicketIfExists')" /><hr />
        <FlyAmericaStatus @flyAmericaActCompliance="getRules" :value="getValue('flyAmericaActCompliance')"/><hr />

        <h1>Car Rules</h1> 
        <CarAverageDailyCost @carDailyCost="getRules" :value="getValue('carDailyCost')" /><hr />
        <CarVendor @carPreferredVendor="getRules"  :value="getValue('carPreferredVendor')" /><hr />
        <CarSize @carSizeGreaterThan="getRules" :value="getValue('carSizeGreaterThan')" /><hr />

        <h1>Hotel Rules</h1> 
        <HotelDailyCostExceptionCities  @hotelDailyCostWithExceptions="getRules" :value="getValue('hotelDailyCostWithExceptions')" /><hr/>
        <!-- <HotelAverageDailyCost @hotelDailyCost="getRules" /><hr /> -->
        <HotelCheapestRate @hotelCheapestRate="getRules" :value="getValue('hotelCheapestRate')" /><hr/>
        <HotelVendor @hotelPreferredVendor="getRules" :value="getValue('hotelPreferredVendor')" /><hr />
        <HotelRefundable @hotelRefundable="getRules" :value="getValue('hotelNonRefundable')" /><hr/>
    </div>
</template>
<script>
import Alltrips from './Rules/Alltrips.vue'
import ClassOfService from './Rules/ClassOfService.vue';
import CarSize from './Rules/CarSize.vue';
import DomesticAirFareCap from './Rules/DomesticAirFareCap.vue';
import InternationalAirFareCap from './Rules/InternationalAirFareCap.vue';
import PurchaseAirlines from './Rules/PurchaseAirlines.vue';
import AirlineVendor from './Rules/AirlineVendor.vue';
import CarVendor from './Rules/CarVendor.vue';
import HotelVendor from './Rules/HotelVendor.vue';
// import HotelAverageDailyCost from './Rules/HotelAverageDailyCost.vue';
import CarAverageDailyCost from './Rules/CarAverageDailyCost.vue';
import HotelDailyCostExceptionCities from './Rules/HotelDailyCostExceptionCities.vue';
import LowestLogicalAirfare from './Rules/LowestLogicalAirfare.vue';
import HotelCheapestRate from './Rules/HotelCheapestRate.vue';
import AirHideNDC from './Rules/AirHideNDC.vue';
import AirRefundable from './Rules/AirRefundable.vue';
import HotelRefundable from './Rules/HotelRefundable.vue';
import UnusedTickets from '@/components/TravelPolicy/Rules/UnusedTickets.vue';
import FlyAmericaStatus from '@/components/TravelPolicy/Rules/FlyAmericaStatus.vue';

export default {
    name : "Rules",
    props: {
    travelPolicy: {
      type: [Object],
    },
  },

    components :{
        ClassOfService,CarSize,DomesticAirFareCap,InternationalAirFareCap,PurchaseAirlines,AirlineVendor,CarVendor,HotelVendor,
        // HotelAverageDailyCost,
        CarAverageDailyCost,Alltrips,HotelDailyCostExceptionCities,LowestLogicalAirfare,HotelCheapestRate,AirHideNDC,AirRefundable,HotelRefundable,
        UnusedTickets,FlyAmericaStatus
    },
    data(){
        return{
           obj:{
            rules :[]
           }
        }
    },
    methods : {
        updateRules(val){
            let index = this.obj.rules.findIndex((f => f.name === val.name));
            if(index == -1) {
                this.obj.rules.push(val)
            } else {
                this.obj.rules[index] = val;
            }
        },
        getValue(name){
            
            if(this.obj){
                return this.obj.rules.find((f => f.name == name));

            }
            else return null;
            
            
        },
        getRules(val) {
           
            this.updateRules(val);
            this.$emit('rules',this.obj);
        }
    },
    mounted(){
        this.$emit('rules',this.obj);

    },
    watch: {
        travelPolicy: {
            handler(newVal) {
            if (newVal && newVal.simplePolicyConfig) {
                const jsonData = JSON.parse(JSON.stringify(newVal.simplePolicyConfig));
                this.obj.rules = jsonData.rules || [];
                this.$emit('rules', this.obj);
            }
            },
            deep: false,
            immediate: true
        }
    }

}
</script>

